import React from 'react';
import {
    Box,
    Heading,
    Text,
    Flex,
    VStack,
    Tag
} from '@chakra-ui/react';
import {
    FiShoppingCart,
    FiCreditCard,
    FiCalendar,
    FiUsers,
} from 'react-icons/fi';

const CommonUseCases = () => {
    const useCases = [
        {
            id: 1,
            category: 'E-commerce',
            categoryColor: 'purple',
            icon: FiShoppingCart,
            title: 'Order Status Updates',
            description: 'Track when order confirmation, shipping, and delivery messages are sent to customers.',
        },
        {
            id: 2,
            category: 'Banking',
            categoryColor: 'green',
            icon: FiCreditCard,
            title: 'Transaction Alerts',
            description: 'Create events for transaction notifications, OTP deliveries, and security alerts sent to customers.',
        },
        {
            id: 3,
            category: 'Healthcare',
            categoryColor: 'orange',
            icon: FiCalendar,
            title: 'Appointment Reminders',
            description: 'Log events when appointment confirmations and reminder messages are sent to patients.',
        },
        {
            id: 4,
            category: 'SaaS',
            categoryColor: 'blue',
            icon: FiUsers,
            title: 'User Onboarding',
            description: 'Track welcome messages, feature announcements, and tutorial notifications sent to new users.',
        },
    ];

    const categoryColors = {
        purple: { bg: '#ad46ff', text: 'white' },
        green: { bg: '#00c951', text: 'white' },
        orange: { bg: '#ff6900', text: 'white' },
        blue: { bg: '#2b7fff', text: 'white' },
    };

    return (
        <Box >
            <Text fontSize="20px" fontWeight="600" color="#000000" my="0px" >
                Common Use Cases
            </Text>
            
            <VStack spacing={4} align="stretch">
                {useCases.map((useCase) => {
                    const IconComponent = useCase.icon;
                    const colors = categoryColors[useCase.categoryColor];
                    
                    return (
                        <Box
                            key={useCase.id}
                            p={6}
                            bg="white"
                            borderWidth="1px"
                            borderColor="gray.200"
                            borderRadius="lg"
                            _hover={{
                                boxShadow: 'md',
                                borderColor: 'gray.300',
                            }}
                            transition="all 0.2s"
                        >
                            <Flex align="flex-start" gap={4}>
                                <Tag
                                    bg={colors.bg}
                                    color={colors.text}
                                    size={"sm"}
                                    borderRadius="md"
                                    fontSize="xs"
                                    
                                    textTransform="capitalize"
                                >
                                    {useCase.category}
                                </Tag>
                                
                                <Box flex={1}>
                                    <Flex align="center" gap={2} mb={2}>
                                        {/* <Box as={IconComponent} fontSize="18px" color="gray.600" /> */}
                                        <Heading size="sm" fontWeight="semibold">
                                            {useCase.title}
                                        </Heading>
                                    </Flex>
                                    <Text color="gray.600" fontSize="sm">
                                        {useCase.description}
                                    </Text>
                                </Box>
                            </Flex>
                        </Box>
                    );
                })}
            </VStack>
        </Box>
    );
};

export default CommonUseCases;